// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"f8-z"};